(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["imperial-cart-cro"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncCartOverlayState() {
      var drawer = document.querySelector('cart-drawer');
      document.body.classList.toggle(
        'imperial-cart-cro-active',
        Boolean(drawer && drawer.classList.contains('active'))
      );
    }

    function initialiseCartOverlayState() {
      var drawer = document.querySelector('cart-drawer');
      syncCartOverlayState();

      if (!drawer) return;

      new MutationObserver(syncCartOverlayState).observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    function applyProductUtilityEnhancements() {
      if (!document.body.classList.contains('page-product')) return false;

      document.documentElement.style.setProperty(
        '--imperial-preview-bar-height',
        document.querySelector('#PBarNextFrame') ? '6.4rem' : '0px'
      );

      var countrySelector = document.querySelector('.bacurr-cur-block');
      var mainContent = document.querySelector('#MainContent');

      if (countrySelector && mainContent) {
        countrySelector.style.setProperty(
          '--imperial-product-country-top',
          Math.max(8, mainContent.offsetTop + 8) + 'px'
        );
      }

      var chat = document.querySelector('shopify-chat');
      var labels = document.querySelector('#ImperialProductUtilityLabels');
      var chatRoot = chat && chat.shadowRoot;
      var chatLabel = chatRoot && chatRoot.querySelector('.activator__label');
      var chatButton = chatRoot && chatRoot.querySelector('[part~="activator"]');

      if (chatLabel && labels) {
        chatLabel.textContent = labels.dataset.chatLabel;
      }

      if (chatButton && labels) {
        chatButton.setAttribute('aria-label', labels.dataset.chatAria);
      }

      return Boolean(countrySelector && chatLabel && chatButton);
    }

    function initialiseProductStickyFallback() {
      if (!document.body.classList.contains('page-product')) return;

      var sticky = document.querySelector('[data-imperial-product-mobile-atc]');
      var stickyButton = sticky && sticky.querySelector('[data-imperial-product-mobile-atc-button]');
      var nativeSticky = document.querySelector('[data-imperial-watch-sticky], [data-it-mobile-purchase]');
      var sourceButton = document.querySelector('.product-form__submit[name="add"], .product-form__submit');

      if (!sticky || !stickyButton || nativeSticky || !sourceButton) return;

      sticky.hidden = false;
      var sourceVisible = true;
      var mobileQuery = window.matchMedia('(max-width: 749px)');

      function paintStickyFallback() {
        var drawerActive = document.body.classList.contains('imperial-cart-cro-active');
        var mobile = mobileQuery.matches;
        var canAdd = !sourceButton.disabled && sourceButton.getAttribute('aria-disabled') !== 'true';
        var shouldShow = mobile && canAdd && !sourceVisible && !drawerActive;
        var sourceLabel = sourceButton.textContent.trim();
        var labelNode = stickyButton.querySelector('span');

        sticky.classList.toggle('is-visible', shouldShow);
        stickyButton.disabled = !canAdd;
        if (labelNode && sourceLabel) labelNode.textContent = sourceLabel;
      }

      stickyButton.addEventListener('click', function () {
        if (!sourceButton.disabled && sourceButton.getAttribute('aria-disabled') !== 'true') {
          sourceButton.click();
        }
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sourceVisible = Boolean(entries[0] && entries[0].isIntersecting);
          paintStickyFallback();
        }, { threshold: 0.01 }).observe(sourceButton);
      } else {
        var fallbackScrollPaint = function () {
          sourceVisible = sourceButton.getBoundingClientRect().bottom >= 0;
          paintStickyFallback();
        };
        window.addEventListener('scroll', fallbackScrollPaint, { passive: true });
      }

      new MutationObserver(paintStickyFallback).observe(sourceButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true
      });

      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', paintStickyFallback);
      window.addEventListener('resize', paintStickyFallback, { passive: true });
      paintStickyFallback();
    }

    function initialiseProductUtilities() {
      if (!document.body.classList.contains('page-product')) return;

      var attempts = 0;
      var utilityTimer = window.setInterval(function () {
        attempts += 1;
        if (applyProductUtilityEnhancements() || attempts >= 40) {
          window.clearInterval(utilityTimer);
        }
      }, 250);

      applyProductUtilityEnhancements();
      window.addEventListener('resize', applyProductUtilityEnhancements, { passive: true });
    }

    function initialiseImperialCro() {
      initialiseCartOverlayState();
      initialiseProductUtilities();
      initialiseProductStickyFallback();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseImperialCro, { once: true });
    } else {
      initialiseImperialCro();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
